// extracted by mini-css-extract-plugin
export var createdDate = "_ny-1";
export var divider = "_ny-2";
export var headerDivider = "_ny-3";
export var messagesCard = "_ny-0";
export var messagesContainer = "_ny-7";
export var messagesContainerWrapper = "_ny-4";
export var pointerCapturingButtonBoxes = "_ny-a";
export var showLeftPanelButton = "_ny-9";
export var showMoreButton = "_ny-c";
export var showMoreButtonContainer = "_ny-b";
export var summaryTitle = "_ny-6";
export var systemMessageCardWrapper = "_ny-d";
export var topButtons = "_ny-8";
export var withPadding = "_ny-5";